export const tiptapWrapProps = {
  /**
   * HTML content
   */
  value: { type: String, default: '' },

  /**
   * 'title', 'location', 'company', field name or any other unique string
   */
  editorId: { type: String, default: '' },

  placeholder: { type: String, default: '' },
  isReadOnly: { type: Boolean, default: false },
  isLocked: { type: Boolean, default: false },

  disabledNodes: { type: Object, default: () => ({}) },

  tiptapConfigOverride: { type: Object, default: () => ({}) },
  highlights: { type: Array, default: () => [] },
  nudges: { type: Array, default: () => [] },

  aiSuggestions: { type: Object, default: () => ({}) },
  aiSuggestionsLoading: { type: Object, default: () => ({}) }, // pinia ref object

  focusedEditorId: { type: String, default: '' },
};
